export const ACCESS_TOKEN = 'mtoken'
export const AUTHORIZATION = 'Authorization'